import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'number_workers_who_are_trainees_apprentices_interns'

export const dataPointDefinition = {
  retracedId: 'number_workers_who_are_trainees_apprentices_interns',
  name: 'Number of workers who are trainees, apprentices or interns:',
  description:
    'Apprenticeship refers to a period of time in which individuals (apprentices) receive in depth on the job training for a trade or craft from person(s) that are highly skilled in that particular trade or craft. Government-driven apprenticeship programs, if applicable, are included in scope. ',
  meta: {
    slcpMeta: {
      key: 'fp-ed-13',
      number: 'FP-WOR-27',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {type: 'object', properties: {value: {type: 'string'}}, required: ['value']},
  externalIds: [{id: 'fp-ed-13', version: '1.7.0', provider: 'slcp'}],
  sortingId: 27670,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
